module.exports = __webpack_public_path__ + "img/home_image_6.f879436e.jpg";